export const ENDPOINTS = {
  login: `/auth/login`,
  googleLogin: `/auth/google`,
  config: `/auth/config`,
  refresh: `/auth/refresh`,
  verifyToken: (token: string) => `/auth/token/${token}`,
  me: `/api/users/me`,
  askPassword: `/auth/ask-password`,
  validateResetPasswordLink: (token: string) => `/auth/reset-password/${token}`,
  resetPassword: `/auth/reset-password`,
  userSettings: `/api/users/me/settings`,
  userSettingsLogo: `/api/users/me/settings/logo`,
};

export const AUTH_QUERY_CACHE = {
  RESET_PASSWORD_LINK: "RESET_PASSWORD_LINK",
  USER_SETTINGS: "USER_SETTINGS",
  SAVE_USER_SETTINGS: "SAVE_USER_SETTINGS",
  UPLOAD_USER_LOGO: "UPLOAD_USER_LOGO",
  DELETE_USER_LOGO: "DELETE_USER_LOGO",
};
